import { lazy } from 'react';
import { SUBSCRIPTION_PERMISSIONS } from './constants';

const SubscriptionListPage = lazy(() => import('./pages/SubscriptionListPage'));
const PlanListPage = lazy(() => import('./pages/PlanListPage'));

export const subscriptionRoutes = [
  {
    path: '/subscriptions',
    element: SubscriptionListPage,
    permission: SUBSCRIPTION_PERMISSIONS.MANAGE,
    nav: { labelKey: 'nav.subscriptions', icon: 'CrownOutlined', group: 'commerce' },
  },
  {
    path: '/subscriptions/plans',
    element: PlanListPage,
    permission: SUBSCRIPTION_PERMISSIONS.MANAGE,
    nav: { labelKey: 'nav.subscriptionPlans', icon: 'TagsOutlined', group: 'commerce' },
  },
];
